import { render } from "./modelContent.vue?vue&type=template&id=d96953d8&scoped=true"
import script from "./modelContent.vue?vue&type=script&lang=js"
export * from "./modelContent.vue?vue&type=script&lang=js"

import "./modelContent.vue?vue&type=style&index=0&id=d96953d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d96953d8"]])

export default __exports__